import React from "react";
import ViewOrderDetails from "./ViewOrderDetails";
import { useParams } from "react-router";

function RateContractViewWrapper() {
  let { orderNumber }: any = useParams();
  return (
    <ViewOrderDetails
      orderNumber={orderNumber}
      previousPath="/view-rate-contract"
      extra={{
        hideAside: true,
        reduceTableWidth: 130,
      }}
    />
  );
}

export default RateContractViewWrapper;
